module.exports = __webpack_public_path__ + "fonts/DB-Heavent-Med-v3.2.ef0ab8eb.ttf";